import { render, staticRenderFns } from "./AdminServiceLog.vue?vue&type=template&id=f041069c&scoped=true"
import script from "./AdminServiceLog.vue?vue&type=script&lang=js"
export * from "./AdminServiceLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f041069c",
  null
  
)

export default component.exports